import SimpleDialog from './mmDialog.vue';

SimpleDialog.install = (Vue) => {
  Vue.component(SimpleDialog.name, SimpleDialog);
};

export default SimpleDialog;
